import { BridgeComponent } from '@hotwired/hotwire-native-bridge';

// Lands the widget token in the native App Group so WidgetKit can fetch
// GET /widget without seeing the WKWebView cookie jar (docs/WIDGET.md).
export default class extends BridgeComponent {
  static component = 'widget';

  connect() {
    super.connect();
    const token = this.bridgeElement.bridgeAttribute('token');
    const url = this.bridgeElement.bridgeAttribute('url');
    if (!token || !url) return;
    this.send('connect', { token, url });
  }
}
